module.exports = __webpack_public_path__ + "img/work1.4430d961.png";